import API from '../../sunwiseAPI';

const ENTITY = 'recalculate-bag';

export const recalculate = (projectId) =>
    API.post(`/api/v1/${ENTITY}/${projectId}/sunpay/`);
